export default function Hero() {
  return (
    <section id="hero" className="relative w-full min-h-[560px] md:h-[640px] flex items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=editorial%20warm%20paper%20texture%20background%20with%20layered%20crimson%20and%20caramel%20ink%20washes%20and%20fine%20grain%2C%20abstract%20journalistic%20composition%20with%20generous%20negative%20space%2C%20soft%20chiaroscuro%2C%20museum%20print%20aesthetic%2C%20no%20text&width=1800&height=1100&seq=hero-kanliao-x1&orientation=landscape"
        alt="看料门事件梳理专题封面背景，暖色纸质编辑风"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-background-50/70" />

      <div className="relative w-full max-w-4xl mx-auto px-4 md:px-6 pt-20 pb-16 text-center">
        <p className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-background-50/15 border border-background-50/30 text-background-50 text-xs md:text-sm tracking-widest mb-6">
          <i className="ri-focus-3-line w-4 h-4 flex items-center justify-center" />
          事件深度梳理 · 全网信息专题
        </p>

        <h1 className="font-heading font-bold text-3xl md:text-5xl text-background-50 leading-snug">
          看料门事件
          <span className="block mt-1 text-accent-300 text-xl md:text-3xl font-medium">
            来龙去脉与时间线 · 完整梳理全记录
          </span>
        </h1>

        <p className="mt-5 text-background-100/90 text-sm md:text-lg max-w-2xl mx-auto leading-relaxed">
          从起因、经过到发酵、澄清，层层拆解这场争议事件的脉络。教你如何分辨哪些是实锤、
          哪些只是传闻，把散落在各处的信息，按可信的时间节点一条条排清楚。
        </p>

        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
          <a
            href="#intro"
            className="inline-flex items-center gap-2 bg-background-50 text-primary-600 px-6 py-3 rounded-md font-medium text-sm whitespace-nowrap transition-colors hover:bg-accent-100 w-full sm:w-auto justify-center"
          >
            从事件导读看起
            <i className="ri-arrow-down-line w-4 h-4 flex items-center justify-center" />
          </a>
          <a
            href="#timeline"
            className="inline-flex items-center gap-2 border border-background-50/60 text-background-50 px-6 py-3 rounded-md font-medium text-sm whitespace-nowrap transition-colors hover:bg-white/10 w-full sm:w-auto justify-center"
          >
            直接看时间线
            <i className="ri-time-line w-4 h-4 flex items-center justify-center" />
          </a>
        </div>
      </div>
    </section>
  );
}